import { ScalesIcon, ShoppingBagIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { getPriceRange, getWeightRange } from './helpers'
import * as Styles from './styles'

const Ranges = ({ displayCriteria, storeCurrency, language }) => {
  const theme = useTheme()

  const priceRange = getPriceRange(displayCriteria, storeCurrency, language)
  const weightRange = getWeightRange(displayCriteria)

  return (
    <>
      {priceRange && (
        <>
          |
          <ShoppingBagIcon size={16} color={theme.colors.text.subtle} />
          <Styles.RangesText type="bodySRegular">{priceRange}</Styles.RangesText>
        </>
      )}
      {weightRange && (
        <>
          |
          <ScalesIcon size={16} color={theme.colors.text.subtle} />
          <Styles.RangesText type="bodySRegular">{weightRange}</Styles.RangesText>
        </>
      )}
    </>
  )
}

export default Ranges
